<template>
    <div class="equipe-modal">
        <div class="select">
            <ui-select-v2
                v-if="dataTeams"
                v-model="newTeam"
                label="Equipe:"
                item-label="label"
                return-value="value"
                :data="dataTeams"
                :loading="loadTeams"
                open-event="change-profile-teams"
                ajax-search
                search-event="change-profile-teams"
                @input="setManagers"
            />
        </div>
        <div class="select">
            <div v-if="load" class="load">
                <ui-load-indicator
                    bg-color="#e7e9f4"
                    color="#69D296"
                    :h="30"
                    :stroke="5" />
            </div>
            <ui-select-v2
                v-if="!load && managers"
                v-model="newManager"
                label="Gerente:"
                item-label="label"
                return-value="value"
                :data="managers"
                @input="setEquipe"
            />
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'
import { uiSelectV2       } from '@/components/ui/form'
import { offline         } from '@/services/axios'
export default {
    name: 'ui-equipe-broker',
    components: {
        uiLoadIndicator,
        uiSelectV2,
    },
    props: {
        dataTeams: {
            type: Array,
            default: () => []
        },
        loadTeams: {
            type: Boolean,
            default: false
        },
        user:{
            type: [String, Object],
            default: () => {}
        }
    },
    data() {
        return {
            newTeam: this.user.team.id,
            load: false,
            newManager: null,
            managers: null,
            hasManager: this.user.team.id
        }
    },
    async mounted() {
        if(this.user.team.id && this.dataTeams.length > 0) {
            await this.setManagers()
        }
    },
    
    methods: {
        setManagers(value) {
            if(value == this.hasManager) return
            else this.hasManager = value
            this.load = true
            offline.getManagerByTeam(this.newTeam).then(res => {
                this.managers = []
                if(res.data && res.data.length) {
                    res.data.forEach(element => {
                        this.managers.push({value: element.manager_id, label: element.first_name, id: element.id})
                    });
                } else {
                    this.$emit('input', false)
                    this.load = false
                    return
                }
                this.newManager = this.user.manager.manager_id
                this.$emit('input', false)
                this.load = false
                
            })
        },
        setEquipe() {
            this.$emit('input', {group: 'broker', manager: this.newManager, team: this.newTeam})
        }
    }
}

</script>

<style lang='stylus' scoped>
    @import '../styles.styl'           
</style>